import React, { memo, useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { colors } from '../../../../../theme/colors';
import { Icon } from '../../../../../components/Icon';
import { Grid } from '@chakra-ui/react';
import {
  Authorized,
  AuthorizeView,
  AutocompleteInput,
  Button,
  NotAuthorized,
  TextInput,
  Unform,
} from 'components';
import { debounce } from 'utils/debounce';
import { FormHandles } from '@unform/core';
import { objToQuery, queryToObj } from 'utils/query';
import { routePaths } from 'constants/routes';
import { RouteComponentProps } from 'react-router';
import { getUserData } from 'services/getUserData';
import { getLoggedUser } from 'utils/storage';

interface IProps {
  history: RouteComponentProps['history'];
}
interface IFormData {
  filtro: string;
  temporaryAccess: boolean;
  enabled: boolean;
  employeeDanielLaw: number;
}
export const ToolbarComponent: React.FC<IProps> = ({ history }) => {
  const formRef = useRef<FormHandles>(null);
  const [typeUser, setTypeUser] = useState<string | number | boolean>('');
  const { filtro, temporaryAccess, enabled, employeeDanielLaw } = useMemo(() => {
    return queryToObj(history.location.search) as {
      filtro?: string;
      temporaryAccess?: string;
      enabled?: string;
      employeeDanielLaw?: string;
    };
  }, [history.location.search]);

  const handleSearch = useCallback(() => {
    const formData = formRef.current?.getData() as IFormData;

    const query = objToQuery({ ...formData, page: 0 });

    history.replace(`${routePaths.users}?${query}`);
  }, []);

  const handleGetDataUserLogged = async () => {
    const idLogged = getLoggedUser().id;

    try {
      const userLogged = await getUserData(String(idLogged));
      const dataUserLogged = userLogged.data;
      setTypeUser(dataUserLogged.employeeDanielLaw);
    } catch {}
  };

  useEffect(() => {
    handleGetDataUserLogged();
  }, []);

  return (
    <Unform initialData={{ filtro, temporaryAccess, enabled, employeeDanielLaw }} formRef={formRef}>
      <Grid mt="1rem" mb="1rem" maxH="40px" templateColumns="repeat(5, 1fr)" gap={6} w="100%">
        <TextInput
          border={'1px solid #ACB4BA !important'}
          name="filtro"
          notErrorMargin
          backgroundColor="#fff"
          leftIcon={{ name: 'search', color: 1100 }}
          placeholder="Buscar..."
          onChange={debounce(handleSearch, 1000)}
          onKeyPress={(ev: any) => {
            const keyCode = ev.keyCode ? ev.keyCode : ev.which ? ev.which : ev.charCode;
            if (keyCode === 13) {
              if (ev.stopPropagation) {
                ev.stopPropagation();
                ev.preventDefault();
              }
            }
          }}
        />

        <AutocompleteInput
          name="temporaryAccess"
          placeholder="Tipo de permissão"
          onSelectOption={debounce(handleSearch, 100)}
          options={[
            { label: 'Permanente', value: false },
            { label: 'Temporário', value: true },
          ]}
        />

        <AutocompleteInput
          name="enabled"
          placeholder="Status"
          onSelectOption={debounce(handleSearch, 100)}
          options={[
            { label: 'Ativo', value: true },
            { label: 'Inativo', value: false },
          ]}
        />

        {typeUser === 'CLIENTE_ADMINISTRADOR' ? (
          <AuthorizeView onlyAdmin>
            <Authorized>
              <AutocompleteInput
                name="employeeDanielLaw"
                placeholder="Perfil de acesso"
                onSelectOption={debounce(handleSearch, 100)}
                options={[
                  // { label: 'Daniel Law', value: 'DANIEL_LAW' },
                  { label: 'Cliente Daniel Law', value: 'CLIENTE_DANIEL_LAW' },
                  { label: 'Cliente Administrador', value: 'CLIENTE_ADMINISTRADOR' },
                ]}
              />
            </Authorized>

            <NotAuthorized>
              <span></span>
            </NotAuthorized>
          </AuthorizeView>
        ) : (
          <AuthorizeView onlyAdmin>
            <Authorized>
              <AutocompleteInput
                name="employeeDanielLaw"
                placeholder="Perfil de acesso"
                onSelectOption={debounce(handleSearch, 100)}
                options={[
                  { label: 'Daniel Law', value: 'DANIEL_LAW' },
                  { label: 'Cliente Daniel Law', value: 'CLIENTE_DANIEL_LAW' },
                  { label: 'Cliente Administrador', value: 'CLIENTE_ADMINISTRADOR' },
                ]}
              />
            </Authorized>

            <NotAuthorized>
              <span></span>
            </NotAuthorized>
          </AuthorizeView>
        )}

        <Button
          type="submit"
          ml="auto"
          href={routePaths.newuser}
          style={{ background: colors.brand.green500 }}
        >
          <Icon name="plus" size={1.2} /> &nbsp; Novo Usuário
        </Button>
      </Grid>
    </Unform>
  );
};
export const Toolbar = memo(ToolbarComponent);
